import React from 'react';
import './Section4.css';
import Sec4TestiDevelop from './Sec4TestiDevelop.js';
import Sec4Title from './Sec4Title.js';

const Section4 = () => {
    return (
        <div>
            <Sec4Title></Sec4Title>
            <Sec4TestiDevelop></Sec4TestiDevelop>
        </div>
        
    )
}

export default Section4;